import React, { useState } from 'react';
import * as store from 'store';
import PreSettingDone from '../../templates/pre-setting-done';
import Step from '../../organisms/entry/step';
import OpsNotification from '../../organisms/ops-notification';
import { TextInput, SelectInput, FieldContainer, RadioInput } from "@graffer-inc/graffer-ui";
import CONST from "../../../constants";
import PriceUtil from "../../../utils/price";
import APPLICATION_TYPE from "../../../constants/application-type";
import Format from "../../../utils/format";
import Transition from "../../../utils/transition";
import {connect} from "react-redux";
import Analytics from "../../../analytics";
import DeliveryKitImage from '../../../assets/images/delivery_kit.png';
import WindowKitImage from '../../../assets/images/window_kit.png';

const Main = ({priceTable, entries }) => {

  const isValidCertPeriod = v => v.length > 0;
  const isValidApplicationType = v => v.length > 0;
  const isValidAttorneyAddress = v => formData.isAttorneyApplication ? v.length > 0 : true;
  const isValidAttorneyName = v => formData.isAttorneyApplication ? v.length > 0 : true;

  const initialFormData = store.get(CONST.STORAGE.FORM_DATA);

  const [formData, setFormData] = useState(initialFormData ? {
    certPeriod: initialFormData.certPeriod || '',
    applicationType: initialFormData.applicationType || APPLICATION_TYPE.CODE.DELIVERY,
    isAttorneyApplication: APPLICATION_TYPE.CODE.DELIVERY === initialFormData.applicationType ? false : initialFormData.isAttorneyApplication,
    attorneyAddress: initialFormData.attorneyAddress || '',
    attorneyName: initialFormData.attorneyName || '',
    isWithRevenueStamp: initialFormData.isWithRevenueStamp === undefined || initialFormData.isWithRevenueStamp === null ? true : initialFormData.isWithRevenueStamp,
  } : {
    certPeriod: '',
    applicationType: APPLICATION_TYPE.CODE.DELIVERY,
    isAttorneyApplication: false,
    attorneyAddress: '',
    attorneyName: '',
    isWithRevenueStamp: true,
  });

  const isValidAll = () => isValidCertPeriod(formData.certPeriod) && isValidCertPeriod(formData.certPeriod) && isValidAttorneyAddress(formData.attorneyAddress) && isValidAttorneyName(formData.attorneyName) && isValidApplicationType(formData.applicationType);
  const applicantOptions = [{value: 'SUBMITTER', name: '印鑑提出者本人'}, {value: 'ATTORNEY', name: '代理人'}];
  const revenueStampOptions = [{value: 'YES', name: 'セットで申し込む'}, {value: 'NO', name: 'セットで申し込まない'}];
  const certPeriodOptions = [{value: '', name: '選択してください'}];
  CONST.MASTER.CERT_PERIOD.forEach(c => certPeriodOptions.push({value: String(c.period), name: `${c.period}ヵ月 - ${Format.money(c.price)}円(発行手数料)`}))
  return (
    <PreSettingDone>
      <div className="container">
        <p className="is-size-3 has-text-weight-bold">取得サポートのお申し込み</p>
        <OpsNotification/>
        <div style={{padding: '10px 0 40px 0'}}>
          <Step />
        </div>
        <div className="columns is-centered">
        <div className="column is-8">
          <form onSubmit={e => {
            e.preventDefault();
            const localFormData = {
              certPeriod: formData.certPeriod,
              isAttorneyApplication: formData.isAttorneyApplication,
              attorneyAddress: formData.attorneyAddress,
              attorneyName: formData.attorneyName,
              applicationType: formData.applicationType,
              isWithRevenueStamp: formData.isWithRevenueStamp,
            };
            store.set(CONST.STORAGE.FORM_DATA, localFormData);
            Analytics.entryNewToConfirm(entries.length === 0);
            Transition.goTo('/entries/confirm');
          }}>
            <div style={{padding: '10px 0'}}>
              <FieldContainer name="電子証明書の証明期間" required>
                <p className="is-size-7 has-text-grey">登記変更を行うと電子証明書が失効する場合があります。登記変更のタイミングを踏まえた証明期間を選択してください。</p>
                <p className="is-size-7 has-text-grey">申請時に証明期間に応じた発行手数料を納付する必要があります。詳細は<a href="http://www.moj.go.jp/MINJI/minji06_00028.html#02" target="_blank" rel="noopener noreferrer">こちら</a>をご覧ください。</p>
                <br/>
                <SelectInput
                  value={formData.certPeriod}
                  validate={isValidCertPeriod}
                  options={certPeriodOptions}
                  onChange={v => setFormData(
                    (f) => {
                      f.certPeriod = v;
                      return Object.assign({}, f);
                    })}
                />
              </FieldContainer>
              <div style={{padding: '20px 0'}}>

                <FieldContainer name="申請プラン" required>
                  <p className="is-size-7 has-text-grey">申請プランごとに取得サポートキットの内容が異なります。どちらかのプランを選択してください。</p>
                  <br/>
                  <div className="columns">
                    <div className="column">
                      <div
                        className={`plan-select-box ${formData.applicationType === APPLICATION_TYPE.CODE.WINDOW ? 'plan-select-box-selected' : ''}`}
                        onClick={() => {
                          setFormData(
                            (f) => {
                              f.applicationType = APPLICATION_TYPE.CODE.WINDOW;
                              return Object.assign({}, f);
                            });
                        }}
                      >
                        <div className="is-flex" style={{justifyContent: 'space-between'}}>
                          <div>
                            <input
                              type="radio"
                              value={APPLICATION_TYPE.CODE.WINDOW}
                              checked={formData.applicationType === APPLICATION_TYPE.CODE.WINDOW}
                              onChange={()=>{}}
                            />
                            <span style={{paddingLeft: '10px'}} className="has-text-weight-bold is-size-5">窓口申請プラン</span>
                          </div>
                          <div>
                            <span className="is-size-5">{priceTable ? Format.money(PriceUtil.withTax(priceTable.price, priceTable.tax)) : '-'}</span><span className="is-size-7" style={{padding: '0 0 0 5px'}}>円(税込)</span>
                          </div>
                        </div>
                        <div style={{padding: '10px 0'}}>
                          <img className="plan-select-box-image" src={WindowKitImage} alt="窓口申請キット"/>
                        </div>
                        <div className="is-size-7" style={{padding: '10px 0 20px 0'}}>
                          <p>当社からお送りする申請書に押印して、窓口の申請に必要な一式を持って、管轄の登記所で申請を行います。</p>
                          <p>申請準備は押印するだけ。</p>
                        </div>
                        <div className="is-size-7">
                          <p><span className="has-text-weight-bold">・管轄の登記所が近い</span></p>
                          <p><span className="has-text-weight-bold">・管轄の登記所に別件で行く予定がある</span></p>
                          <p className="has-text-right" style={{padding: '5px 0 0 0'}}>などの場合にオススメです。</p>
                        </div>
                      </div>
                    </div>
                    <div className="column">
                      <div
                        className={`plan-select-box ${formData.applicationType === APPLICATION_TYPE.CODE.DELIVERY ? 'plan-select-box-selected' : ''}`}
                        onClick={() => {
                          setFormData(
                            (f) => {
                              f.applicationType = APPLICATION_TYPE.CODE.DELIVERY;
                              f.isAttorneyApplication = false;
                              return Object.assign({}, f);
                            });
                        }}
                      >
                        <div className="is-flex" style={{justifyContent: 'space-between'}}>
                          <div>
                            <input
                              type="radio"
                              value={APPLICATION_TYPE.CODE.DELIVERY}
                              checked={formData.applicationType === APPLICATION_TYPE.CODE.DELIVERY}
                              onChange={()=>{}}
                            />
                            <span style={{paddingLeft: '10px'}} className="has-text-weight-bold is-size-5">郵送申請プラン</span>
                          </div>
                          <div>
                            <span className="is-size-5">{priceTable ? Format.money(PriceUtil.withTax(priceTable.deliveryPrice, priceTable.tax)) : '-'}</span><span className="is-size-7" style={{padding: '0 0 0 5px'}}>円(税込)</span>
                          </div>
                        </div>
                        <div style={{padding: '10px 0'}}>
                          <img className="plan-select-box-image" src={DeliveryKitImage} alt="郵送申請キット"/>
                        </div>
                        <div className="is-size-7" style={{padding: '10px 0 20px 0'}}>
                          <p>当社からお送りする申請書に押印して、同封の申請用レターパックライトに一式を入れ、ポストに投函するだけで申請が完了します。配送状況も追跡可能。</p>
                        </div>
                        <div className="is-size-7">
                          <p><span className="has-text-weight-bold">・管轄の登記所が遠い</span></p>
                          <p><span className="has-text-weight-bold">・申請にかかる人件費などのコストを大幅に削減したい</span></p>
                          <p className="has-text-right" style={{padding: '5px 0 0 0'}}>などの場合にオススメです。</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </FieldContainer>
              </div>

              <div style={{padding: '20px 0'}}>
                <div>
                  <FieldContainer name="申請者" required>
                    <p className="is-size-7 has-text-grey">申請者が代理人の場合、申請書に「登記所に提出した印鑑」と「代理人の認印」の2つの押印が必要です。</p>
                    <p className="is-size-7 has-text-grey">郵送申請プランの場合、申請者は印鑑提出者本人となります。</p>
                    <br/>
                    <RadioInput
                      disabled={formData.applicationType === APPLICATION_TYPE.CODE.DELIVERY}
                      value={formData.isAttorneyApplication ? 'ATTORNEY' : 'SUBMITTER'}
                      options={applicantOptions}
                      onChange={v => setFormData(
                        (f) => {
                          f.isAttorneyApplication = v === 'ATTORNEY';
                          return Object.assign({}, f);
                        })}
                    />
                  </FieldContainer>
                </div>
                {
                  formData.isAttorneyApplication && (
                    <div style={{padding: '15px 0 0 15px'}}>
                      <FieldContainer name="代理人の氏名" required>
                        <TextInput
                          value={formData.attorneyName}
                          errorMessage="入力してください"
                          validate={isValidAttorneyName}
                          placeholder="代理人太郎"
                          onChange={v => setFormData(
                            (f) => {
                              f.attorneyName = v;
                              return Object.assign({}, f);
                            })}
                        />
                      </FieldContainer>
                      <FieldContainer name="代理人の現住所" required>
                        <TextInput
                          placeholder="東京都代理区代理町100-10-1"
                          value={formData.attorneyAddress}
                          errorMessage="入力してください"
                          validate={isValidAttorneyAddress}
                          onChange={v => setFormData(
                            (f) => {
                              f.attorneyAddress = v;
                              return Object.assign({}, f);
                            })}
                        />
                      </FieldContainer>
                    </div>
                  )
                }
              </div>

              <div style={{padding: '20px 0'}}>
                <div>
                  <FieldContainer name="発行手数料分の収入印紙" required>
                    <p className="is-size-7 has-text-grey">
                      証明期間に応じた発行手数料分の収入印紙を申請書に貼り付ける必要があります。セットで申し込むと収入印紙が貼り付けられた状態で申請書が届きます。<span className="is-highlight">セットで申し込まれない場合は、ご自身で収入印紙を準備する必要があります。</span></p>
                    <p className="is-size-7 has-text-grey">収入印紙セット料金として、発行手数料に加えて、事務手数料が発行手数料の{priceTable ? priceTable.revenueStampFeeRate : '-'}%かかります。</p>
                    <br/>
                    <RadioInput
                      value={formData.isWithRevenueStamp ? 'YES' : 'NO'}
                      options={revenueStampOptions}
                      onChange={v => setFormData(
                        (f) => {
                          f.isWithRevenueStamp = v === 'YES';
                          return Object.assign({}, f);
                        })}
                    />
                  </FieldContainer>
                </div>
              </div>
            </div>
            <div className="has-text-right">
              <p>
                合計金額<span className="is-size-4" style={{padding: '0 5px'}}>{!priceTable || !formData.applicationType || formData.certPeriod.length === 0 ? '-' : Format.money(PriceUtil.getTotalPrice(priceTable, formData))}</span>円(税込)
              </p>
              {
                !formData.isWithRevenueStamp ? (
                  <p className="is-size-7 has-text-grey"><span className="is-highlight">別途、ご自身で発行手数料分の収入印紙を準備する必要があります。ご認識の上、お申し込みください。</span></p>
                ) : formData.certPeriod.length === 0 ? (
                  <p className="is-size-7 has-text-grey">電子証明書の証明期間を選択してください。</p>
                ) : null
              }
            </div>
            <div className="has-text-centered" style={{padding: '20px 0 0 0'}}>
              <button
                type="submit"
                disabled={!isValidAll()}
                className="button is-accent is-rounded is-fullwidth"
              >
                申し込み内容の確認に進む
              </button>
            </div>
          </form>
        </div>
        </div>
      </div>
    </PreSettingDone>
  )
};

export default connect(
  store => ({
    priceTable: store.user.priceTable,
    entries: store.user.entries,
  }),
)(Main);